import React from "react";
import Tabs from "react-bootstrap/lib/Tabs";
import Tab from "react-bootstrap/lib/Tab";
import Events from "./Events";
import Preachers from "./Preachers";

const EventsPreachersTab = props =>
  <Tabs defaultActiveKey={1} id="events_preachers_tab">
    <Tab eventKey={1} title="Events">
      <Events />
    </Tab>
    <Tab eventKey={2} title="Preachers">
      <Preachers />
    </Tab>
  </Tabs>;

export default EventsPreachersTab;



// WEBPACK FOOTER //
// ./src/components/EventsPreachersTab.js